import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { NAME } from '#client/build-env';
import { EnterpriseNextUp } from '#client/components/EnterpriseHome/EnterpriseNextUp';
import { EnterpriseOrderTracker } from '#client/components/EnterpriseHome/EnterpriseOrderTracker';
import { ErrorStateSection } from '#client/components/ErrorStateSection';
import { ProfileHeader } from '#client/components/ProfileHeader';
import { useEnterpriseProfileStatus } from '#client/hooks/enterpriseHome/useEnterpriseProfileStatus';

function EnterpriseHome({ enterprise }) {
  const { formatMessage } = useIntl();
  const {
    statusItems, loading, hasError, name, nameInitials, formationDate
  } = useEnterpriseProfileStatus({ enterprise });

  return (
    <Stack spacing={{ xs: 2, sm: 3 }}>
      <ErrorBoundary fallback={<ErrorStateSection />} id={`${NAME}/pages/EnterpriseHome#ProfileHeader`}>
        <ProfileHeader
          statusItems={statusItems}
          loading={loading}
          hasError={hasError}
          name={name}
          nameInitials={nameInitials}
          formationDate={formationDate}
        />
      </ErrorBoundary>
      <ErrorBoundary fallback={<ErrorStateSection title={formatMessage({ id: 'dashboard.enterpriseNextUp.title' })} />} id={`${NAME}/pages/EnterpriseHome#NextUp`}>
        <EnterpriseNextUp />
      </ErrorBoundary>
      <ErrorBoundary fallback={<ErrorStateSection title={formatMessage({ id: 'dashboard.orderTracker.title' })} />} id={`${NAME}/pages/EnterpriseHome#EnterpriseOrderTracker`}>
        <EnterpriseOrderTracker />
      </ErrorBoundary>
    </Stack>
  );
}

EnterpriseHome.propTypes = {
  enterprise: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
};

export default EnterpriseHome;
